import { asyncTimeout } from '../async/asyncTimeout';
import type { ServiceDocument } from '../dto/ServiceDocumentDtos';
import type { AxiosInstance } from 'axios';

const SERVICEDOCUMENT_TIMEOUT_MS = 30000;

/**
 * @param serviceDocumentUrl A url like "https://foo.bar/api/v1"
 */
export async function fetchServiceDocument(
  serviceDocumentUrl: string,
  axiosInstance: AxiosInstance
): Promise<ServiceDocument> {
  const http = axiosInstance;
  while (true) {
    try {
      const response = await http.get<ServiceDocument>(
        `${serviceDocumentUrl}?ts=${new Date().getTime()}`,
        { timeout: SERVICEDOCUMENT_TIMEOUT_MS }
      );
      return response.data;
    } catch (err: any) {
      // Let's retry so that when we serve things locally, we don't get stuck if we ask
      // for the service document before the lambda server is ready to answer
      console.error(`Could not load service document from ${serviceDocumentUrl}`, err);
      await asyncTimeout(4000);
    }
  }
}
